/* TODO: Update description */

<template>
  <div
    class="sidebar-page"
    v-if="sidebarObj.originalAnnotation != undefined && open == true"
  >
    <dialog id="sideBarDialog">
      <h2>Delete this annotation</h2>
      <form method="dialog">
        <button @click="deleteAnnotation">Yes, I'm sure</button
        >&nbsp;&nbsp;&nbsp;
        <button>No</button>
      </form>
    </dialog>

    <section class="sidebar-layout o-side__overlay">
      <o-sidebar
        position="absolute"
        :mobile="mobile"
        :open="open"
        :overlay="overlay"
        :fullheight="fullheight"
        :fullwidth="fullwidth"
        :right="right"
      >
        <section style="padding: 1em">
          <o-field
            label="Annotation quality:"
            variant=""
            v-if="
              sidebarObj.originalAnnotation.sidebarObj[
                'ods:annotationQuality'
              ] != ''
            "
          >
            {{ sidebarObj.originalAnnotation.sidebarObj["annotationQuality"] }}
          </o-field>

          <o-field
            label="Score:"
            variant=""
            v-if="sidebarObj.originalAnnotation.sidebarObj['score'] != ''"
          >
            {{ sidebarObj.originalAnnotation.sidebarObj["score"] }}
          </o-field>

          <o-field
            label="Comments:"
            variant=""
            v-if="sidebarObj.originalAnnotation.sidebarObj['textComment'] != ''"
            ><div
              v-html="sidebarObj.originalAnnotation.sidebarObj['textComment']"
            />
          </o-field>

          <o-field
            label="Add own comment:"
            variant=""
            v-if="sidebarObj.annotationEditMod"
          >
            <o-input v-model="ownComment" type="textarea"></o-input>
          </o-field>

          <!-- DROPDOWN -->
          <o-field label="Vernacular name:" variant="">
            <o-dropdown
              aria-role="list"
              v-model="dropdownSelectedItem"
              :disabled="disableDropDown"
              @change="setTaxonID"
            >
              <template #trigger="{ active }">
                <o-button variant="primary">
                  <span>{{
                    dropdownIDtoName[dropdownSelectedItem]["vernacularName"]
                  }}</span>
                  <o-icon
                    pack="fa"
                    :icon="active ? 'chevron-down' : 'chevron-up'"
                  ></o-icon>
                </o-button>
              </template>

              <o-dropdown-item
                v-for="(item, key) in dropdownIDtoName"
                :key="key"
                :value="key"
                aria-role="listitem"
              >
                {{ item["vernacularName"] }}</o-dropdown-item
              >
            </o-dropdown>
          </o-field>

          <o-field
            label="Scientific name:"
            variant=""
            v-if="dropdownSelectedItem != 'NIL'"
          >
            {{ dropdownIDtoName[dropdownSelectedItem]["scientificName"] }}
          </o-field>

          <br /><o-button
            :label="'Close'"
            :variant="'info'"
            @click="this.open = false"
          />

          <br /><o-button
            style="margin-top: 0.5em"
            v-if="!disableDropDown"
            :label="'DELETE'"
            :variant="'danger'"
            @click="showDeleteDialog"
          />
          <!-- <br />disableDropDown: {{ disableDropDown }} -->
          <!-- <br /><br />sidebarObj.annotationEditMod
          {{ sidebarObj.annotationEditMod }} -->
        </section>
      </o-sidebar>
    </section>
  </div>
</template>

<script>
export default {
  name: "SidebarComponent",
  props: ["sidebarObj"],
  emits: ["setOwnComment", "setTaxonID", "delete"],

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  data() {
    return {
      open: this.sidebarObj.open,
      mobile: "reduced",
      overlay: false,
      fullheight: true,
      fullwidth: false,
      right: false,

      ownComment: "",

      // dialogRef: ref(0),

      dropdownIDtoName: {
        ["NIL"]: {
          ["vernacularName"]: "Not in list",
          ["scientificName"]: "Not in list",
        },
        ["https://www.gbif.org/species/5219426"]: {
          ["vernacularName"]: "Jaguar",
          ["scientificName"]: "Panthera onca (Linnaeus, 1758)",
        },
        ["https://www.gbif.org/species/2441022"]: {
          ["vernacularName"]: "Aurochs",
          ["scientificName"]: "Bos taurus Linnaeus, 1758",
        },
        ["https://www.gbif.org/species/2440995"]: {
          ["vernacularName"]: "Collared Peccary",
          ["scientificName"]: "Pecari tajacu (Linnaeus, 1758)",
        },
      },
      dropdownSelectedItem: "NIL",
      disableDropDown: true,
    };
  },

  methods: {
    setTaxonID(id) {
      this.$emit("setTaxonID", id);
    },

    showDeleteDialog() {
      document.getElementById("sideBarDialog").showModal();
    },

    deleteAnnotation() {
      // console.log("sidebarObj", this.sidebarObj.originalAnnotation.id);
      // var id = this.sidebarObj.originalAnnotation.id.split("_");

      // if (Array.isArray(id)) {
      //   if (id.length > 1) {
      //     id = id[0]; // Necessary for some browser.
      //     this.$emit("delete", id, "cordra");
      //   } else {
      //     this.$emit("delete", id, "local");
      //   }
      // }

      this.$emit("delete", this.sidebarObj.originalAnnotation.id);
    },
  },

  computed: {},

  watch: {
    ownComment(newValue) {
      this.$emit("setOwnComment", newValue);
    },

    sidebarObj: {
      handler(newValue) {
        console.log("watch newValue start", newValue);
        this.open = false;

        if (newValue.originalAnnotation != undefined) {
          // Animal name
          if (
            newValue.originalAnnotation.sidebarObj["taxonID"] != undefined &&
            newValue.originalAnnotation.sidebarObj["taxonID"] in
              this.dropdownIDtoName
          ) {
            this.dropdownSelectedItem =
              newValue.originalAnnotation.sidebarObj["taxonID"];
          } else {
            this.dropdownSelectedItem = "NIL";
          }

          // Own Comment
          this.ownComment = newValue.originalAnnotation.sidebarObj.ownComment;

          // An own annotation
          this.disableDropDown = !(
            newValue.originalAnnotation.sidebarObj["ownAnnotation"] &&
            newValue.annotationEditMod
          );

          this.open = newValue.open;
        }
      },
      deep: true,
    },
  },
};
</script>

<style>
.animation-content {
  z-index: 0;
}
</style>

<style scoped>
.sidebar-page {
  display: contents;
  width: 100%;
  /* min-height: 100%; */
}

.sidebar-layout {
  display: flex;
  flex-direction: row;
  /* min-height: 100%; */
}
</style>
